import {StyledSlider} from "../../../templates/cashmere25/components"

const Cashmere25StyledSlider = StyledSlider

export default Cashmere25StyledSlider
